































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import PageNames from '@/router/PageNames';
import { PersonModule } from '@/store/Customers/PersonModule';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';

@Component({ name: 'RelatedCustomers' })
export default class extends SaascadaVue {

    EntityType = EntityType;

	@Prop({required: true})
	entityType: EntityType;

    headers = [
        { text: this.$t('pageText.customers.fields.name'), width: '50%' },
        { text: this.$t('pageText.customers.fields.accountHolders'), width: '50%' }
    ];
    relatedCustomersPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.relatedCustomersPage = +page;
        }
    }

    async beforeMount() {
        if (this.entityType === EntityType.Organisation) {
            await OrganisationModule.getRelatedCustomers(this.relatedCustomersPage);
        }
        else {
            await PersonModule.getRelatedCustomers(this.relatedCustomersPage);
        }
    }

    @Watch('relatedCustomersPage')
    async onRelatedCustomersPage() {
        // Update route with tab and page number (if it has changed)
        if (this.relatedCustomersPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.relatedCustomersPage}` } });
        }
        // Get new related customers
        if (this.entityType === EntityType.Organisation) {
            await OrganisationModule.getRelatedCustomers(this.relatedCustomersPage);
        }
        else {
            await PersonModule.getRelatedCustomers(this.relatedCustomersPage);
        }
    }

    get relatedCustomers() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.relatedCustomers;
        }
        else {
            return PersonModule.relatedCustomers;
        }
    }

    get loading() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.loadingRelatedCustomers;
        }
        else {
            return PersonModule.loadingRelatedCustomers;
        }
    }

    get totalRelatedCustomersPages() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.totalRelatedCustomersPages;
        }
        else {
            return PersonModule.totalRelatedCustomersPages;
        }
    }

    get pageSize() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.pageSize;
        }
        else {
            return PersonModule.pageSize;
        }
    }

    async goToCustomer(customerID: string) {
        this.$router.push({ name: PageNames.Customer, params: { id: customerID } });
    }

}
